export function schema_mapping_colonnes_fichier_cible(
	prevColumnNames,
	columns
) {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			colonnes: {
				type: "array",
				format: "table",
				title: "Mapping",
				items: {
					type: "object",
					title: "Mapping",
					properties: {
						colonne: {
							title: "Colonne",
							type: "string",
							options: {
								inputAttributes: {
									class: "form-control dropdown-colonne",
								},
							},
						},
						mapping: {
							title: "Mapping",
							type: "string",
						},
					},
				},
				default: columns,
			},
		},
	};
}
